module.exports = __webpack_public_path__ + "canon.jpg?a843129fcbe8378614b5bd3125bfe3a7";